import { useState } from "react";
import { useLoad, rp, Metric, inputCls, Sel, Field } from "./kit";
import { useLists } from "./RequestForm";

const CARDS = [
  ["allocated_paise", "Project budgets allocated"], ["deposits_received_paise", "Deposits received"], ["advances_paid_paise", "Advances paid"],
  ["vendor_expenses_paise", "Vendor expenses"], ["internal_expenses_paise", "Internal employee expenses"], ["bills_submitted_paise", "Bills submitted", "bills_submitted"],
  ["bills_approved_paise", "Bills approved", "bills_approved"], ["payments_released_paise", "Payments released"], ["outstanding_vendor_paise", "Outstanding vendor payments", null, "text-rose-700"],
  ["pending_reimbursements_paise", "Pending employee reimbursements", null, "text-amber-700"], ["unused_advance_paise", "Unused advance balances"],
  ["carried_forward_paise", "Carried forward (available credit)", null, "text-emerald-700"],
];

export function FaDashboard() {
  const { projects, vendors, people } = useLists();
  const [f, setF] = useState({});
  const qs = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
  const [d] = useLoad(`/fa/dashboard?${qs}`);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));
  return (
    <div className="space-y-5" data-testid="fa-dashboard">
      <div className="grid grid-cols-2 gap-2 rounded-xl border border-[#D6C6B0] bg-white/60 p-3 md:grid-cols-4 xl:grid-cols-8" data-testid="fa-dashboard-filters">
        <Field label="Project"><Sel testid="fd-project" value={f.project_id} onChange={set("project_id")} options={projects} placeholder="All" /></Field>
        <Field label="Client"><input data-testid="fd-client" className={inputCls} value={f.client || ""} onChange={set("client")} /></Field>
        <Field label="Employee"><Sel testid="fd-employee" value={f.employee_id} onChange={set("employee_id")} options={people} placeholder="All" /></Field>
        <Field label="Vendor"><Sel testid="fd-vendor" value={f.vendor_id} onChange={set("vendor_id")} options={vendors} placeholder="All" /></Field>
        <Field label="Department"><input data-testid="fd-department" className={inputCls} value={f.department || ""} onChange={set("department")} /></Field>
        <Field label="Status"><Sel testid="fd-status" value={f.status} onChange={set("status")} placeholder="All"
          options={["Submitted", "Accounts Verified", "Awaiting Approval", "Approved", "Payment Initiated", "Paid", "Under Review", "Partially Paid", "Rejected"]} /></Field>
        <Field label="From"><input data-testid="fd-from" type="date" className={inputCls} value={f.date_from || ""} onChange={set("date_from")} /></Field>
        <Field label="To"><input data-testid="fd-to" type="date" className={inputCls} value={f.date_to || ""} onChange={set("date_to")} /></Field>
      </div>
      {d && (
        <>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-4">
            {CARDS.map(([k, l, cnt, tone]) => <Metric key={k} testid={`fd-metric-${k}`} label={l} tone={tone} value={`${rp(d[k])}${cnt ? ` · ${d[cnt]}` : ""}`} />)}
          </div>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
            <Metric testid="fd-pending-approvals" label="Pending finance approvals" value={d.pending_approvals} tone="text-amber-700" />
            <Metric testid="fd-pending-requests" label="Pending payment requests" value={d.pending_requests} />
            <Metric testid="fd-pending-bills" label="Bills awaiting review" value={d.pending_bills} />
            <Metric testid="fd-overdue-bills" label="Overdue bills" value={d.overdue_bills} tone="text-rose-700" />
          </div>
        </>
      )}
    </div>
  );
}
